<template>
  <div class="card my-4">
    <div class="card-body card-body-sm text-center">
      Full Release History →
      <a target="_blank" href="https://github.com/bradsiefert/highbeam-design-system">
        Highbeam Design System on Github
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GithubLink'
}
</script>
